var codeblock_default = {
  "blockStyleSpacing": "JpYeV",
  "codeBlock": "SjWZH JpYeV",
  "renderedInTable": "Z2X4c"
};
export {
  codeblock_default as default
};
//# sourceMappingURL=codeblock-scss.js.map
